export const _INIT_PROFILE = '_INIT_PROFILE';

